import Head from 'next/head'

export default function NextHead() {
  return (
    <Head>
      <meta charSet="utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=Edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />

      <meta name="format-detection" content="telephone=no" />

      <link
        rel="preload"
        as="style"
        href="https://cdn.hippoparking.ru/area/files/491712539/slick.min.css"
      />
      <link rel="icon" href="/favicon.ico" />
      <link rel="icon" type="image/png" href="/favicon.png" sizes="32x32" />

      <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
      <link rel="apple-touch-icon-precomposed" href="/apple-touch-icon-precomposed.png" />
      <link
        rel="stylesheet"
        type="text/css"
        charSet="UTF-8"
        href="https://cdn.hippoparking.ru/area/files/491712539/slick.min.css"
      />
      <meta name="msapplication-TileColor" content="#FFFFFF" />
      <meta name="theme-color" content="#FFFFFF" />
      <script
        id="yandex-metrika"
        dangerouslySetInnerHTML={{
          __html: `
   (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)}; 
   m[i].l=1*new Date(); 
   for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }} 
   k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)}) 
   (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym"); 
  
   ym(99998859, "init", { 
        clickmap:true, 
        trackLinks:true, 
        accurateTrackBounce:true, 
        webvisor:true 
   });
          `,
        }}
      />
    </Head>
  )
}
